import React from 'react';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import { get } from 'lodash';
import CommonPropTypes from '../../../common/PropTypes';
import TrackingNumber from '../../PatientsPage/components/TrackingNumber';

const useStyles = makeStyles(() => {
  return {
    container: {
      display: 'flex',
      flexDirection: 'column'
    }
  };
});

const PatientColumn = ({ patient }) => {
  const classes = useStyles();
  const doctor = patient.user;

  const renderPatientName = () => {
    return <>{patient.formatted_name}</>;
  };

  const handleTrackingNumberClick = () => {
    const courier = get(patient, 'rx_form.courier');
    if (courier) {
      window.open(courier.link, '_blank');
    }
  };

  return (
    <>
      <div className={classes.container}>
        <div>
          {renderPatientName()}
          <>
            <Typography variant="caption" component="div" color="textSecondary">
              Dr. {doctor.full_name}
            </Typography>
            <TrackingNumber
              rxForm={get(patient, 'rx_form')}
              onClickTrackingNumber={handleTrackingNumberClick}
            />
          </>
        </div>
      </div>
    </>
  );
};

PatientColumn.propTypes = {
  patient: CommonPropTypes.patient.isRequired
};

export default PatientColumn;
